import { useEffect, useState } from "react";

import { Dialog } from "@/design-system/components/Dialog/Dialog";
import { Badge } from "@/design-system/components/Badge/Badge";
import { Button } from "@/design-system/components/Button/Button";
import settingsTeamImage from "@/img/settings-team.png";

const STORAGE_KEY = "fp_settings_welcome_mat_seen";

function hasSeenWelcomeMat(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return true;
  }
}

function markWelcomeMatSeen(): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, "true");
  } catch {
    // Nothing to recover: the flag just isn't persisted for this session.
  }
}

export const SettingsWelcomeMat = () => {
  const [open, setOpen] = useState(() => !hasSeenWelcomeMat());

  // Mark as seen as soon as it's shown so a reload or navigation before the
  // user dismisses it won't bring the modal back.
  useEffect(() => {
    if (open) {
      markWelcomeMatSeen();
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onOpenChange={setOpen}
      ariaLabel="Settings, all in one place"
      contentProps={{ className: "w-2xl" }}
      media={
        <>
          <img
            className="h-auto w-full"
            width={1500}
            height={700}
            alt="New Organization settings navigation bar, with General, Team members, Projects, and AI usage pages listed. The team members page is active."
            src={settingsTeamImage}
          />
          <Badge text="New" className="absolute top-6 left-4 z-10" />
        </>
      }
    >
      <div className="flex flex-col gap-4">
        <h2>Settings, all in one place</h2>
        <p>
          We've made it easier to manage settings across your organization,
          projects, and environments.
        </p>
        <Button onClick={() => setOpen(false)} className="self-start">
          Got it
        </Button>
      </div>
    </Dialog>
  );
};
